export default __webpack_public_path__ + "static/media/laptop_fr.07385ea5.png";